import { Icons } from '@vertex-protocol/web-ui';
import { formatAmount } from 'client/modules/collateral/nadoDeposit/utils/formatAmount';
import { GAS_AIRDROP_CONFIG } from 'client/modules/collateral/nadoDeposit/config/oft';

interface Props {
  /** Human-readable gas airdrop amount (e.g. "0.0005") */
  gasAirdropAmount?: string;
}

/**
 * Warning banner shown during cross-chain deposits when the user has
 * insufficient ETH on Ink to cover transaction fees.
 *
 * The bridge will automatically airdrop a small amount of ETH alongside
 * the USDT0 transfer to cover first-time gas costs.
 */
export function NadoGasAlert({ gasAirdropAmount }: Props) {
  // Default to the config amount if not provided
  const displayAmount =
    gasAirdropAmount ??
    formatAmount(Number(GAS_AIRDROP_CONFIG.defaultAmount) / 1e18);

  return (
    <div
      className="bg-warning-muted border-warning flex items-start gap-x-2 rounded-sm border px-3 py-2.5"
      role="alert"
    >
      <Icons.Warning className="text-warning mt-0.5 size-4 flex-shrink-0" />
      <p className="text-warning text-xs leading-relaxed">
        You don&apos;t have gas on Ink. The bridge will include{' '}
        <span className="font-semibold">~{displayAmount} ETH</span> for
        transaction fees.
      </p>
    </div>
  );
}
